import React from 'react';
import { useNotify } from 'react-admin';
import { GetAppRounded } from '@material-ui/icons';
import { Filter } from '@/components/Global';
import { ParseExportInventoryList } from '@/actions/ParseData';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import {
  getExportInventory,
  delExportInventory,
  SaveApiResMessage,
} from '@/actions';
import Add from './Add';
import List from './List';
// import Edit from './Edit';
import styles from './styles';
import Pagination from '@/components/pagination';

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [state, setState] = React.useState({
    edit: null,
    file: null,
  });
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const [loading, setLoading] = React.useState(true);
  const [DATA, setData] = React.useState([]);
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });
  const Del = (id) => {
    alert('api not exist');
    // delExportInventory(id)
    //   .then((msg) => {
    //     notify(msg);
    //     getExportInventory()
    //       .then((res) => {
    //         let DATA = ParseExportInventoryList(res.data);
    //         setData(DATA);
    //         setFilter({ ...filter, DATA });
    //         setLoading(false);
    //       })
    //       .catch((err) => notify(err, 'warning'));
    //   })
    //   .catch((err) => notify(err, 'warning'));
  };

  const openPopUp = (item) => {
    noScroll();
    setState({ ...state, edit: item });
  };

  const Update = (form, inventory_id, containers) => {};

  const closePopup = () => {
    removeNoScroll();
    setState({ ...state, edit: null });
  };

  const handleExport = () => {};

  const getExportInventoryList = () => {
    setLoading(true);
    getExportInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseExportInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        setFilter({ open: false, DATA });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    // getExportInventoryList();
  }, [pagination.currentPage]);

  return (
    <div className={cls.content}>
      <div className={cls.cardHeader}>
        <span className={cls.title}>Add Export</span>
      </div>
      <Add
        notify={notify}
        setData={(res) => {
          let DATA = ParseExportInventoryList(res);
          setData(DATA);
          setFilter({ ...filter, DATA });
        }}
        getExportInventoryList={getExportInventoryList}
      />
      <Filter
        title="All Exports"
        filter={filter}
        setFilter={setFilter}
        DATA={DATA}>
        <span className={cls.title}>Export</span>
        <span className={cls.titleBlue} onClick={handleExport}>
          XLSX
        </span>
      </Filter>

      <List
        DATA={filter.DATA}
        Del={Del}
        Edit={openPopUp}
        currentPage={pagination.currentPage}
      />
      <Pagination pagination={pagination} setPagination={setPagination} />
    </div>
  );
};
